import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import Sidebar from "./Sidebar";
import Backdrop from "../Elements/Backdrop";
import PdfModal from "../Elements/PdfModal";
import { navLinks, documentLinks } from "./documentLinks";
import MyLogo from "../../assets/img/add/Omni.png";
import BurgerIcon from "../../assets/svg/BurgerIcon";

export default function TopNavbar() {
  const [scrolled, setScrolled] = useState(window.scrollY > 24);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeDocument, setActiveDocument] = useState(null);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={setSidebarOpen} openModal={setActiveDocument} />
      {sidebarOpen && <Backdrop toggleSidebar={setSidebarOpen} />}
      <PdfModal document={activeDocument} onClose={() => setActiveDocument(null)} />
      <Wrapper $scrolled={scrolled} aria-label="Primary navigation">
        <NavInner className="container">
          <BrandLink to="home" smooth offset={-84} aria-label="Omnicom Solutions home">
            <img src={MyLogo} alt="Omnicom Solutions" />
          </BrandLink>
          <DesktopNav>
            {navLinks.map((link) => (
              <li key={link.to}>
                <NavLink activeClass="active" to={link.to} spy smooth offset={link.offset}>
                  {link.label}
                </NavLink>
              </li>
            ))}
            <li>
              <DocumentsMenu>
                <summary>Documents <span aria-hidden="true">⌄</span></summary>
                <DocumentPopover>
                  <small>Company documents</small>
                  {documentLinks.map((doc) => (
                    <button key={doc.id} type="button" onClick={() => setActiveDocument(doc)}>
                      <span>{doc.label}</span><b aria-hidden="true">↗</b>
                    </button>
                  ))}
                </DocumentPopover>
              </DocumentsMenu>
            </li>
            <li><ContactLink to="contact" smooth offset={-70}>Start a conversation</ContactLink></li>
          </DesktopNav>
          <BurgerButton type="button" aria-label="Open navigation" onClick={() => setSidebarOpen(true)}>
            <BurgerIcon />
          </BurgerButton>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  inset: 0 0 auto;
  z-index: 999;
  height: ${({ $scrolled }) => ($scrolled ? "72px" : "88px")};
  display: flex;
  align-items: center;
  background: ${({ $scrolled }) => ($scrolled ? "rgba(255,255,255,.94)" : "rgba(255,255,255,.82)")};
  border-bottom: 1px solid ${({ $scrolled }) => ($scrolled ? "#e5e8e6" : "transparent")};
  box-shadow: ${({ $scrolled }) => ($scrolled ? "0 8px 30px rgba(23,21,47,.07)" : "none")};
  backdrop-filter: blur(18px);
  transition: 0.25s ease;
`;
const NavInner = styled.div`display: flex; align-items: center; justify-content: space-between; height: 100%;`;
const BrandLink = styled(Link)`
  display: inline-flex; align-items: center; cursor: pointer;
  img { width: 184px; height: 44px; object-fit: contain; }
  @media (max-width: 440px) { img { width: 155px; height: 38px; } }
`;
const DesktopNav = styled.ul`
  display: flex; align-items: center; gap: 2px;
  @media (max-width: 1040px) { display: none; }
`;
const NavLink = styled(Link)`
  position: relative; display: inline-flex; padding: 12px 11px; cursor: pointer;
  color: #353747; font-size: .78rem; font-weight: 700;
  &::after { content: ""; position: absolute; left: 11px; right: 11px; bottom: 5px; height: 2px; background: #0a9250; transform: scaleX(0); transition: .2s ease; }
  &:hover { color: #0a9250; }
`;
const ContactLink = styled(Link)`
  display: inline-flex; margin-left: 8px; padding: 11px 17px; border-radius: 999px;
  background: #17152f; color: white; font-size: .76rem; font-weight: 800; cursor: pointer;
  &:hover { background: #0a9250; color: white; transform: translateY(-1px); }
`;
const DocumentsMenu = styled.details`
  position: relative;
  summary { list-style: none; display: flex; gap: 6px; align-items: center; padding: 12px 11px; color: #353747; font-size: .78rem; font-weight: 700; cursor: pointer; }
  summary::-webkit-details-marker { display: none; }
  &[open] summary { color: #0a9250; }
`;
const DocumentPopover = styled.div`
  position: absolute; top: calc(100% + 12px); right: 0; width: 290px; padding: 12px;
  border: 1px solid #e3e7e5; border-radius: 18px; background: #fff; box-shadow: 0 24px 60px rgba(23,21,47,.16);
  small { display: block; padding: 8px 10px; color: #0a9250; font-size: .66rem; font-weight: 800; letter-spacing: .12em; text-transform: uppercase; }
  button { width: 100%; display: flex; justify-content: space-between; gap: 14px; padding: 11px 10px; border: 0; border-radius: 10px; background: transparent; color: #252737; text-align: left; font-size: .78rem; cursor: pointer; }
  button:hover { background: #f2f6f3; color: #0a9250; }
`;
const BurgerButton = styled.button`
  display: none; align-items: center; justify-content: center; width: 46px; height: 46px;
  border: 1px solid #e3e7e5; border-radius: 50%; background: white; cursor: pointer;
  @media (max-width: 1040px) { display: inline-flex; }
`;
